import numeral from 'numeral'

export function formatNumeric(value, format) {
  numeral.nullFormat('')
  return numeral(value).format(format)
}
